module.exports = __webpack_public_path__ + "fonts/display-bold.16a03474.woff2";